import { render, staticRenderFns } from "./bottomlist.vue?vue&type=template&id=3b8f058f&scoped=true"
import script from "./bottomlist.vue?vue&type=script&lang=js"
export * from "./bottomlist.vue?vue&type=script&lang=js"
import style0 from "./bottomlist.vue?vue&type=style&index=0&id=3b8f058f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8f058f",
  null
  
)

export default component.exports